export interface CameraQRReaderProps {
    className?: string;
    style?: React.CSSProperties;
    onScan?: (data: string) => void;
    onError?: (error: Error) => void;
    onPermissionDeniedError?: (error: Error) => void;
    cameraPosition?: "front" | "back";
}

export enum CameraQRReaderErrors {
    PERMISSION_DENIED = "Permission denied",
}
